import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./avenir-next/890bd988-5306-43ff-bd4b-922bc5ebdeb4.ttf%22,%22variable%22:%22--font-avenir-next-bold%22}],%22variableName%22:%22avenirNextBold%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avenirNextBold', 'avenirNextBold Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
